// /api/coach/detail?company_code=85046666

import { request } from "../../apis";
import { PostProfileParams } from "./data";

export const apiGetProfile = (): any =>
  request("get", `/api/user/detail`, null, true);

export const apiPostProfile = (params: PostProfileParams): any =>
  request("post", `/api/user/detail`, params, true, true);
